import { useState } from 'react';
import { calculateQuote } from '../../services/calculator/calculateQuoteService.js';

const initialForm = {
    resourceTypeId: '',
    extensionUnitCode: '',
    extensionQuantity: '',
    multimediaLevelId: '',
    instructionalLevelId: '',
    activitiesCount: 0
};

const WARNING_MESSAGES = {
    DURATION_OVER_60: 'La duración supera los 60 minutos, por favor acuda a su contacto en TAEC.',
    VIDEO_DURATION_OVER_10: 'La duración del video supera los 10 minutos. por favor acuda a su contacto en TAEC.'
};

export function useCalculator() {
    const [form, setForm] = useState(initialForm);
    const [result, setResult] = useState(null);
    // Modal informativo (>60 min)
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [infoMessage, setInfoMessage] = useState('');
    // Modal de error
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const submit = async () => {
        setShowErrorModal(false);
        setErrorMessage('');
        setResult(null);

        try {
            const data = await calculateQuote({
                resourceTypeId: Number(form.resourceTypeId),
                multimediaLevelId: Number(form.multimediaLevelId),
                instructionalLevelId: Number(form.instructionalLevelId),
                extensionUnitCode: form.extensionUnitCode,
                extensionQuantity: Number(form.extensionQuantity),
                activitiesCount: Number(form.activitiesCount) || 0
            });

            setResult(data);

            if (data.warnings?.length) {
                const warningKey = data.warnings[0]; // normalmente solo uno
                const message = WARNING_MESSAGES[warningKey];

                if (message) {
                    setInfoMessage(message);
                    setShowInfoModal(true);
                }
            }

        } catch (err) {
            setErrorMessage(
                err.response?.data?.message ||
                'Error al calcular la cotización.'
            );
            setShowErrorModal(true);
        }
    };

    const closeInfoModal = () => {
        setShowInfoModal(false);
        setInfoMessage('');
    };
    const closeErrorModal = () => {
        setShowErrorModal(false);
        setErrorMessage('');
    };
    
    return {
        form,
        handleChange,
        submit,
        result,
        showInfoModal,
        infoMessage,
        showErrorModal,
        closeInfoModal,
        closeErrorModal,
        errorMessage
    };
}